"use server";

import { auth } from "./auth";

/**
 * Retrieves the current authenticated user.
 *
 * @returns {Promise<any>} A promise that resolves to the current authenticated user.
 */
export async function getCurrentUser(): Promise<any> {
  return await auth();
}

/**
 * Logs out the current authenticated user.
 *
 * @param {any} payload - The payload sign and authenticate
 * @returns {Promise<void>}
 */
export async function loginUser(payload: any): Promise<void> {}

/**
 * Logs out the current authenticated user.
 *
 * @returns {Promise<void>}
 */
export async function logoutUser(): Promise<void> {}
